import React, { useEffect, useRef, useState } from 'react';
import './TextAnalytics.scss';
import { BaseWidget } from 'models/WidgetModel';
import { useStore as useGlobalStore } from 'store/useGlobalStore';
import TACardWidget from 'components/TACardWidget/TACardWidget';
import {
  buildTADateFilter,
  getHostDateSelection,
  getSessionDateSelection,
  isSameTADateFilter,
} from './dateFilterUtils';

const TextAnalytics: React.FC<BaseWidget> = ({ ...props }) => {
  const { options } = props;
  const [childrenWidgets, setChildrenWidgets] = useState<any[]>([]);
  const [selectedWidget, setSelectedWidget] = useState<any>();
  const [dateSelection, setDateSelection] = useState(
    () => getSessionDateSelection() || getHostDateSelection()
  );
  const lastSessionValue = useRef(window.sessionStorage.getItem('filter-bar-storage'));
  const lastHostValue = useRef(window.localStorage.getItem('hostStore'));
  const { setState, currentDateFilter } = useGlobalStore((state) => ({
    setState: state.setState,
    currentDateFilter: state.dateFilter,
  }));
  // Get values coming from cx2 object
  const globalFiltersBarFilters = window.globalFiltersBarFilters || {};

  const calendarFilter = (globalFiltersBarFilters?.FilterBarValues ?? []).find(
    (x: any) => x.Source === 'Calendar'
  );

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      const sessionValue = window.sessionStorage.getItem('filter-bar-storage');
      const hostValue = window.localStorage.getItem('hostStore');
      const sessionChanged = sessionValue !== lastSessionValue.current;
      const hostChanged = hostValue !== lastHostValue.current;
      if (!sessionChanged && !hostChanged) return;

      lastSessionValue.current = sessionValue;
      lastHostValue.current = hostValue;

      const nextSelection = hostChanged ? getHostDateSelection() : getSessionDateSelection();
      if (nextSelection) setDateSelection(nextSelection);
    }, 250);

    return () => window.clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const nextDateFilter = buildTADateFilter(dateSelection, calendarFilter?.Values);
    if (!isSameTADateFilter(currentDateFilter, nextDateFilter)) {
      setState({ dateFilter: nextDateFilter });
    }
  }, [calendarFilter, currentDateFilter, dateSelection, setState]);

  useEffect(() => {
    if (options?.childrenWidgets && options?.childrenWidgets.length) {
      setChildrenWidgets(options.childrenWidgets);
      setSelectedWidget(options.childrenWidgets[0]);
    }
  }, [options]);

  return (
    <div className="text-analytics-widget">
      {childrenWidgets ? (
        <div className="main-widgets">
          {childrenWidgets.map((widget: any, i: number) => {
            const { dependencyOn } = widget;
            if (!dependencyOn) {
              return (
                <TACardWidget
                  key={i}
                  selectedWidget={selectedWidget}
                  setSelectedWidget={setSelectedWidget}
                  {...widget}
                />
              );
            }
          })}
        </div>
      ) : null}
      {selectedWidget ? (
        <div className="dependent-widgets">
          {childrenWidgets.map((widget: any, i: number) => {
            const { dependencyOn } = widget;
            if (dependencyOn && dependencyOn.includes(selectedWidget.payload.actionName)) {
              return <TACardWidget key={i} {...widget} />;
            }
          })}
        </div>
      ) : null}
    </div>
  );
};

export default TextAnalytics;
